import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * HandymanFinalPaymentPage — service removed.
 * Redirects to the orders page.
 */
const HandymanFinalPaymentPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/orders', { replace: true });
  }, [navigate]);

  return null;
};

export default HandymanFinalPaymentPage;
